<script>
    import {players} from '../store';
    import {createEventDispatcher} from 'svelte';
    import {Toast} from 'svelma';
    import {HalfItHistoryEvent} from "../halfit.model";
    import SpinningWheel from "./SpinningWheel.svelte";
    import {HistoryEventType} from "../history-events.enum";
    import {HistoryEvent} from "../tactics.model";

    const dispatch = createEventDispatcher();

    export let rounds;
    export let funHalfIt;
    export let luckyLevel;
    export let halfItQuickGame;
    export let roundModeReversed;
    export let spinningWheelData;

    let currentScore = null;
    let currentRound = 0;
    let activePlayerIndex = 0;
    let scoreInputElement;
    let history = [];
    let spinHistory = [];

    let gameFinished = false;
    let ranking = null;
    let spinWheelActive = false;

    function handleEndRound(score) {
        if (score == null || isNaN(score)) {
            score = 0;
        }

        if (rounds[currentRound] === 'Scoring round' && score === 0) {
            Toast.create({message: 'You must have hit something?!', type: 'is-danger'});
            return;
        }

        if (rounds[currentRound] !== 'Triple' && rounds[currentRound] !== 'Double' && rounds[currentRound] !== 'Scoring round') {
            if (!funHalfIt && !isValidScore(score)) {
                Toast.create({message: 'More than maximum number entered!', type: 'is-danger'});
                return;
            }

            if (rounds[currentRound] === 'Bull') {
                score = score * 25;
            } else {
                score = score * parseInt(rounds[currentRound]);
            }
        }

        addScore(parseInt(score));
        next();

        if (scoreInputElement) {
            scoreInputElement.focus();
        }
    }

    function handleShanghai() {
        addScore(200);
        next();
        if (scoreInputElement) {
            scoreInputElement.focus();
        }
    }

    function isValidScore(score) {
        if (rounds[currentRound] === 'Bull') {
            return score <= 6;
        }

        return score <= 9;
    }

    function addScore(scoreInRound) {
        const previousTotal = $players[activePlayerIndex]?.totalScore;
        const totalAfterRound = calculateNewScore($players[activePlayerIndex]?.totalScore, scoreInRound);
        let activePlayer = $players[activePlayerIndex];
        let segmentData = activePlayer.rounds.filter(item => item.round === rounds[currentRound])[0];
        segmentData.scoreInRound = scoreInRound;
        segmentData.totalAfterRound = totalAfterRound;

        if (scoreInRound === 0) {
            history = [...history, new HalfItHistoryEvent(HistoryEventType.HALF_IT, activePlayerIndex, rounds[currentRound], scoreInRound, previousTotal)];
        } else {
            history = [...history, new HalfItHistoryEvent(HistoryEventType.SEGMENT_HIT, activePlayerIndex, rounds[currentRound], scoreInRound, previousTotal)];
        }

        activePlayer.rounds = [...activePlayer.rounds];

        players.update(players => {
            players[activePlayerIndex].totalScore = totalAfterRound;
            players[activePlayerIndex].rounds = [...players[activePlayerIndex].rounds];
            return [...players];
        });
    }

    function calculateNewScore(oldTotal, score) {
        if (!score || score === 0) return Math.ceil(oldTotal / 2);
        return oldTotal + score;
    }

    function onEnterScore(e) {
        if (e.key === 'Enter' || e.charCode === 13 || e.keyCode === 13) {
            e.preventDefault();
            handleEndRound(currentScore);
        }
    }

    function next() {
        checkWinner();

        if (activePlayerIndex === $players.length - 1) {
            activePlayerIndex = 0;
            currentRound = currentRound + 1;
        } else {
            activePlayerIndex = activePlayerIndex + 1;
        }
        currentScore = null;

        history = [...history, new HalfItHistoryEvent(HistoryEventType.NEXT_PLAYER, activePlayerIndex, currentRound, 0, 0)];

        if (funHalfIt && !gameFinished && currentRound !== 0) {
            setTimeout(() => {
                let randomNumber = Math.floor(Math.random() * 10) + 1;
                if (randomNumber <= luckyLevel) {
                    spinWheelActive = true;
                } else {
                    Toast.create({message: 'No luck...', duration: 1000, position: 'is-bottom'});
                }
            }, 700);
        }
    }

    function checkWinner() {
        if (currentRound === rounds.length - 1 && activePlayerIndex === $players.length - 1) {
            ranking = $players.map((x) => x);
            ranking.sort((player1, player2) => player1.totalScore - player2.totalScore).reverse();

            gameFinished = true;
        }
    }

    function previous() {
        if (activePlayerIndex - 1 < 0) {
            if (currentRound > 0) {
                activePlayerIndex = $players.length - 1;
                currentRound = currentRound - 1;
            }
        } else {
            activePlayerIndex = activePlayerIndex - 1;
        }
    }

    function undo() {
        gameFinished = false;
        let undidSpinHistory = false;
        let lastHistoryItem = history[history.length - 1];

        if (!lastHistoryItem) {
            return;
        }

        let player = $players[lastHistoryItem.playerIndex];
        let segment = lastHistoryItem.segment;

        if (lastHistoryItem.type === HistoryEventType.HALF_IT) {
            let roundSegment = player.rounds.filter(item => item.round === segment)[0];
            player.totalScore = lastHistoryItem.previousTotal;
            roundSegment.scoreInRound = 0;
            roundSegment.totalAfterRound = 0;
        }

        if (lastHistoryItem.type === HistoryEventType.SEGMENT_HIT) {
            let roundSegment = player.rounds.filter(item => item.round === segment)[0];
            player.totalScore = player.totalScore - roundSegment.scoreInRound;
            roundSegment.totalAfterRound = 0;
            roundSegment.scoreInRound = 0;
        }

        if (lastHistoryItem.type === HistoryEventType.SPINNING_WHEEL_MINUS_25_POINTS
            || lastHistoryItem.type === HistoryEventType.SPINNING_WHEEL_PLUS_25_POINTS) {
            spinHistory.pop();
            spinHistory = spinHistory;
            player.totalScore = lastHistoryItem.previousTotal;
        }

        let lastSpinHistoryItem = spinHistory[spinHistory.length - 1];
        if (lastSpinHistoryItem && lastSpinHistoryItem.playerIndex === lastHistoryItem.playerIndex && lastSpinHistoryItem.segment === segment) {
            spinHistory.pop();
            spinHistory = spinHistory;
            undidSpinHistory = true;
        }

        players.update(players => {
            if (players[activePlayerIndex]) {
                players[activePlayerIndex].rounds = [...players[activePlayerIndex].rounds];
            }
            return [...players];
        });

        if (undidSpinHistory && lastHistoryItem.type === HistoryEventType.NEXT_PLAYER) {
            return;
        }

        history.pop();
        history = history;

        if (lastHistoryItem.type === HistoryEventType.NEXT_PLAYER) {
            previous();
            undo();
        }

        if (scoreInputElement) {
            scoreInputElement.focus();
        }
    }

    function reset() {
        activePlayerIndex = 0;
        currentRound = 0;
        gameFinished = false;
        ranking = null;
        spinHistory = [];
        history = [];
        currentScore = null;
        dispatch('reset', {funHalfIt: funHalfIt, luckyLevel: luckyLevel, halfItQuickGame: halfItQuickGame, roundModeReversed: roundModeReversed});

        if (scoreInputElement) {
            scoreInputElement.focus();
        }
    }

    function newGame() {
        dispatch('newGame');
    }

    function init(el) {
        el.focus();
    }

    function isPlayerActive(player) {
        return $players[activePlayerIndex]?.name === player?.name && !gameFinished;
    }

    function isPlayerWinner(player) {
        return gameFinished && ranking && ranking.length > 0 && ranking[0]?.totalScore === player?.totalScore;
    }

    function handleSelectedSpin(event) {
        let selectedSpinEvent = event.detail.event;
        spinWheelActive = false;
        let previousTotal = $players[activePlayerIndex]?.totalScore;

        if (HistoryEventType.SPINNING_WHEEL_MINUS_25_POINTS === selectedSpinEvent) {
            $players[activePlayerIndex].totalScore -= 25;
            if ($players[activePlayerIndex].totalScore < 1) {
                $players[activePlayerIndex].totalScore = 1;
            }
            history = [...history, new HalfItHistoryEvent(selectedSpinEvent, activePlayerIndex, rounds[currentRound], -25, previousTotal)];
        } else if (HistoryEventType.SPINNING_WHEEL_PLUS_25_POINTS === selectedSpinEvent) {
            $players[activePlayerIndex].totalScore += 25;
            history = [...history, new HalfItHistoryEvent(selectedSpinEvent, activePlayerIndex, rounds[currentRound], 25, previousTotal)];
        } else {
            $players[activePlayerIndex].totalScore = $players[activePlayerIndex].totalScore;
        }

        spinHistory = [...spinHistory, new HistoryEvent(selectedSpinEvent, activePlayerIndex, currentRound)];

        if (scoreInputElement) {
            scoreInputElement.focus();
        }
    }

    function checkSpinHistory(round, player) {
        let type = spinHistory.find((r) => r.segment === rounds.indexOf(round) && $players.indexOf(player) === r.playerIndex)?.type;
        let spinningWheelItemModel = spinningWheelData?.find((item) => item.event === type);

        if (spinningWheelItemModel) {
            return "(" + spinningWheelItemModel.label + ")";
        }

        return '';
    }

    function getRoundData(player, round) {
        return player.rounds.find(r => r.round === round);
    }

    function getPlayerRoundTotal(player, round) {
        let rd = getRoundData(player, round);
        return rd && rd.totalAfterRound != null ? rd.totalAfterRound : '';
    }

    function isTurnPlayed(rIndex, pIdx, player, round) {
        let rd = getRoundData(player, round);
        // Turn is played if round segment has been registered or game is beyond this turn
        if (rd && (rd.totalAfterRound > 0 || rd.scoreInRound > 0)) return true;
        return gameFinished || rIndex < currentRound || (rIndex === currentRound && pIdx < activePlayerIndex);
    }

    function isScoreHalved(player, round, rIndex, pIdx) {
        if (!isTurnPlayed(rIndex, pIdx, player, round)) return false;
        let rd = getRoundData(player, round);
        return rd ? rd.scoreInRound === 0 : false;
    }
</script>

{#if spinWheelActive}
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-950/70 backdrop-blur-md">
        <div class="relative w-full max-w-xl bg-white rounded-3xl shadow-2xl border border-black/10 overflow-hidden flex flex-col items-center">
            <button
                class="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-600 flex items-center justify-center transition-colors cursor-pointer border border-slate-200 active:scale-95"
                aria-label="close"
                type="button"
                on:click={() => spinWheelActive = false}
            >
                <span class="material-symbols-outlined text-[20px]">close</span>
            </button>
            <SpinningWheel on:selectedSpin={handleSelectedSpin} playerName="{$players[activePlayerIndex]?.name}" data="{spinningWheelData}"/>
        </div>
    </div>
{/if}

<div class="halfit-screen w-full h-screen min-h-screen text-slate-900 font-sans antialiased flex flex-col p-3 sm:p-4 md:p-5 lg:p-6 box-border" style="background-color: #f0ece9;">
    <!-- BEGIN: TopControlsBar -->
    <header class="w-full max-w-[1600px] mx-auto bg-white rounded-2xl sm:rounded-3xl shadow-sm px-4 sm:px-6 py-3 mb-3 sm:mb-4 border border-black/5 flex flex-wrap items-center justify-between gap-4 shrink-0">
        <!-- Brand Group -->
        <div class="flex items-center gap-4 sm:gap-6 min-w-[180px]">
            <button class="inline-flex items-center transition-opacity hover:opacity-85 focus:outline-none cursor-pointer" on:click={newGame} title="Yuma Home">
                <img alt="Yuma Logo" class="h-8 sm:h-9 w-auto object-contain" src="images/yuma.png" />
            </button>
            <div class="h-8 w-px bg-slate-200"></div>
        </div>

        <!-- Active Input Center Console -->
        <div class="flex items-center justify-center flex-1 max-w-xl mx-auto order-last md:order-none w-full md:w-auto">
            <div class="flex items-center gap-2 w-full max-w-xl bg-stone-100/80 p-1.5 rounded-2xl border border-slate-200 shadow-inner">
                {#if rounds[currentRound] !== 'Triple' && rounds[currentRound] !== 'Double' && rounds[currentRound] !== 'Scoring round' && !gameFinished}
                    <button
                        class="h-11 inline-flex items-center justify-center gap-1.5 bg-[#c4a892] hover:bg-[#b89a83] active:scale-[0.98] text-white font-bold px-4 sm:px-5 rounded-xl transition-all shadow-sm border border-[#b3957f] whitespace-nowrap cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
                        type="button"
                        on:click={handleShanghai}
                        title="Shanghai: 1 single, 1 double & 1 triple (+200 pts)"
                    >
                        <span class="material-symbols-outlined text-[18px]">stars</span>
                        <span>Shanghai</span>
                    </button>
                {/if}

                <div class="relative flex-1 min-w-[180px] sm:min-w-[220px]">
                    <input
                        class="w-full h-11 bg-white text-slate-900 text-lg font-bold pl-4 pr-14 rounded-xl border border-slate-200 placeholder-slate-400 focus:border-[#21e467] focus:ring-2 focus:ring-[#21e467]/30 transition-all text-center tracking-wide outline-none disabled:opacity-50"
                        type="number"
                        min="0"
                        placeholder="Hits / Score..."
                        bind:value={currentScore}
                        on:keydown={onEnterScore}
                        bind:this={scoreInputElement}
                        use:init
                        disabled={gameFinished}
                    />
                    <span class="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-500 font-bold select-none pointer-events-none">
                        {#if rounds[currentRound] !== 'Triple' && rounds[currentRound] !== 'Double' && rounds[currentRound] !== 'Scoring round' && !gameFinished}
                            × {rounds[currentRound]}
                        {:else}
                            PTS
                        {/if}
                    </span>
                </div>

                <button
                    class="h-11 inline-flex items-center justify-center gap-2 bg-[#EBA9FF] hover:bg-[#1bc658] active:scale-[0.98] text-[#005d46] font-bold px-5 sm:px-6 rounded-xl transition-all shadow-sm border border-emerald-500/20 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                    type="button"
                    on:click={() => handleEndRound(currentScore)}
                    disabled={gameFinished}
                >
                    <span>Next player</span>
                    <span class="material-symbols-outlined text-[18px]">arrow_forward</span>
                </button>
            </div>
        </div>

        <!-- Right Quick Actions (Undo, Reset Round, Home) -->
        <div class="flex items-center justify-end gap-2.5 min-w-[180px]">
            <!-- Undo / Previous Turn Button -->
            <button
                class="h-11 w-11 inline-flex items-center justify-center rounded-xl bg-pink-50 hover:bg-pink-100 text-rose-600 transition-colors border border-rose-200/50 cursor-pointer active:scale-95"
                title="Undo last score"
                type="button"
                on:click={undo}
            >
                <span class="material-symbols-outlined text-[20px]">undo</span>
            </button>
            <!-- New Round Button -->
            <button
                class="h-11 inline-flex items-center gap-2 bg-[#6434da] hover:bg-[#5229b5] text-white text-sm font-semibold px-4 rounded-xl transition-colors shadow-sm cursor-pointer active:scale-95"
                type="button"
                on:click={reset}
            >
                <span class="material-symbols-outlined text-[18px]">restart_alt</span>
                <span class="hidden sm:inline">New round</span>
            </button>
            <!-- Exit to Setup / Lobby -->
            <button
                class="h-11 w-11 inline-flex items-center justify-center rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 transition-colors border border-slate-200 cursor-pointer active:scale-95"
                title="Exit to Setup"
                type="button"
                on:click={newGame}
            >
                <span class="material-symbols-outlined text-[20px]">home</span>
            </button>
        </div>
    </header>
    <!-- END: TopControlsBar -->

    <!-- BEGIN: MainScoreboardTable -->
    <main class="w-full max-w-[1600px] mx-auto flex-1 flex flex-col min-h-0">
        <div class="bg-white rounded-2xl sm:rounded-3xl shadow-md border border-black/5 overflow-hidden flex-1 flex flex-col min-h-0">
            <div class="overflow-auto flex-1 flex flex-col min-h-0">
                <table class="w-full h-full text-center border-collapse flex-1">
                    <thead>
                        <!-- Primary Player Header Row -->
                        <tr class="h-12 sm:h-14 text-white text-lg">
                            <!-- Game Mode Header -->
                            <th class="w-[20%] min-w-[160px] bg-[#005d46] px-5 py-2.5 align-middle text-left font-bold text-lg sm:text-xl tracking-tight border-r border-emerald-900/30 text-white" scope="col" style="text-align: left;">
                                <div class="flex items-center justify-start gap-2 sm:gap-3 text-left">
                                    <span class="material-symbols-outlined text-[#21e467] text-[24px] sm:text-[28px] shrink-0">percent</span>
                                    <div class="text-left">
                                        <div class="text-base sm:text-lg md:text-xl font-black font-headline tracking-tight text-white leading-tight flex items-center flex-wrap">
                                            Half it {#if funHalfIt}<span class="text-xs bg-[#21e467] text-[#005d46] px-2 py-0.5 rounded-full uppercase ml-1.5 font-bold">Lucky</span>{/if}
                                        </div>
                                        <div class="text-[11px] sm:text-xs text-emerald-200/80 font-medium">
                                            Hit target or score halves
                                        </div>
                                    </div>
                                </div>
                            </th>

                            <!-- Player Headers -->
                            {#each $players as player, idx}
                                <th
                                    class="px-4 py-2.5 align-middle font-bold border-r transition-colors {
                                        isPlayerWinner(player)
                                            ? 'bg-[#21e467] text-[#005d46] border-emerald-600/40 shadow-sm'
                                            : isPlayerActive(player)
                                            ? 'bg-[#fff8e7] text-amber-950 border-amber-200/80 shadow-inner'
                                            : 'bg-[#005d46] text-white border-emerald-900/30'
                                    }"
                                    scope="col"
                                    style="width: {80 / $players.length}%"
                                >
                                    <div class="flex items-center justify-center gap-2 flex-wrap">
                                        {#if isPlayerActive(player) && !isPlayerWinner(player)}
                                            <span class="inline-block w-2.5 h-2.5 rounded-full bg-[#21e467] border-2 border-emerald-700 animate-pulse"></span>
                                        {/if}
                                        <span class="text-xl sm:text-2xl font-bold font-headline">
                                            {player?.name}
                                        </span>
                                        {#if isPlayerWinner(player)}
                                            <span class="text-xl sm:text-2xl leading-none select-none inline-flex items-center">
                                                🏆
                                            </span>
                                        {/if}
                                    </div>
                                </th>
                            {/each}
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-slate-200/70 text-base font-medium">
                        <!-- ROUNDS -->
                        {#each rounds as round, rIndex}
                            <tr class="round-row transition-colors {
                                rIndex === currentRound
                                    ? 'bg-[#fef0cd]/30 hover:bg-[#fef0cd]/50'
                                    : rIndex % 2 === 0
                                    ? 'bg-white hover:bg-[#f5f3f0]'
                                    : 'bg-[#fbfaf8] hover:bg-[#f5f3f0]'
                            }">
                                <!-- Round Label Column -->
                                <td class="round-label text-left pl-6 sm:pl-8 py-1 sm:py-2 align-middle font-bold border-r border-slate-200 font-headline {
                                    rIndex === currentRound ? 'text-emerald-900' : 'text-slate-600'
                                }">
                                    <div class="flex items-center gap-2.5 h-full min-h-[32px] sm:min-h-[38px]">
                                        {#if rIndex === currentRound && !gameFinished}
                                            <span class="w-3 h-3 rounded-full bg-[#21e467] border-2 border-emerald-600 shrink-0"></span>
                                        {/if}
                                        <span class="text-2xl sm:text-3xl md:text-4xl font-black tracking-tight leading-none font-headline">{round}</span>
                                    </div>
                                </td>

                                <!-- Player Score in this Round -->
                                {#each $players as player, pIdx}
                                    <td class="py-1 sm:py-2 align-middle text-center border-r border-slate-200/50 transition-all {
                                        rIndex === currentRound && pIdx === activePlayerIndex && !gameFinished
                                            ? 'bg-[#fef0cd]/70 border-r border-amber-300/80 font-bold text-amber-950'
                                            : rIndex === currentRound
                                            ? 'bg-[#fff8e7]/30 border-r border-amber-100'
                                            : ''
                                    }">
                                        <div class="flex flex-col items-center justify-center w-full h-full min-h-[32px] sm:min-h-[38px]">
                                            {#if rIndex === currentRound && pIdx === activePlayerIndex && !gameFinished}
                                                <div class="inline-flex items-center justify-center px-3 sm:px-4 py-1 rounded-lg border-2 border-dashed border-amber-400/80 text-amber-800 text-xs sm:text-sm font-semibold animate-pulse box-border">
                                                    Throwing...
                                                </div>
                                            {:else if isTurnPlayed(rIndex, pIdx, player, round)}
                                                {#if isScoreHalved(player, round, rIndex, pIdx)}
                                                    <div class="inline-flex items-center justify-center gap-1.5 text-rose-600 font-bold">
                                                        <span class="text-lg sm:text-xl md:text-2xl leading-none text-rose-600 font-black">{getPlayerRoundTotal(player, round)}</span>
                                                        <span class="text-[10px] sm:text-xs font-extrabold bg-rose-100 text-rose-700 px-1.5 py-0.5 rounded-md uppercase tracking-wider">½</span>
                                                    </div>
                                                {:else}
                                                    <div class="inline-flex items-center justify-center gap-1.5 font-bold">
                                                        <span class="text-lg sm:text-xl md:text-2xl leading-none text-slate-900 font-black">{getPlayerRoundTotal(player, round)}</span>
                                                    </div>
                                                {/if}
                                                {#if checkSpinHistory(round, player)}
                                                    <div class="text-[11px] font-semibold text-purple-700 mt-0.5">{checkSpinHistory(round, player)}</div>
                                                {/if}
                                            {:else}
                                                <span class="text-slate-300 font-bold text-lg sm:text-xl leading-none select-none">-</span>
                                            {/if}
                                        </div>
                                    </td>
                                {/each}
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>

            <!-- Footer Info Strip inside table card -->
            <div class="px-5 sm:px-6 py-2.5 bg-stone-50 border-t border-slate-200/80 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500 font-medium shrink-0">
                <div class="flex items-center gap-3 sm:gap-4">
                    <span class="inline-flex items-center gap-1.5">
                        <span class="w-2 h-2 rounded-full bg-[#21e467]"></span>
                        <strong class="text-slate-700">Half it rules:</strong> Hit the active target or your score is halved (½)
                    </span>
                    <span class="text-slate-300 hidden sm:inline">|</span>
                    <span class="hidden sm:inline">Rounds: {rounds.length}</span>
                </div>
                <div class="flex items-center gap-3">
                    <span class="text-slate-400">Press <kbd class="px-1.5 py-0.5 bg-white border border-slate-300 rounded text-[11px] text-slate-700 font-mono shadow-xs font-semibold">ENTER</kbd> to submit score</span>
                </div>
            </div>
        </div>
    </main>
    <!-- END: MainScoreboardTable -->
</div>

<style>
    /* Custom styles for Half It scoreboard */
    .halfit-screen {
        font-family: 'Space Grotesk', 'Inter', sans-serif;
    }

    .halfit-screen table {
        table-layout: fixed;
    }

    .halfit-screen table th,
    .halfit-screen table td {
        vertical-align: middle !important;
    }

    .halfit-screen .round-row {
        height: 1%;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }
</style>
